import { Injectable, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
@Injectable()


export class MessageService {

    constructor(public toastr: ToastrService, vcr: ViewContainerRef) {
        //this.toastr.setRootViewContainerRef(vcr);
    }

    private subject = new Subject<any>();
    

    showMessage(message: string, type: string) {

        switch (type) {
            case "2":
                this.toastr.success(message, '', { timeOut: 8000 })
                break;
            case "1":
                this.toastr.error(message, '', { timeOut: 6000 });
                break;
            case "3":
                this.toastr.warning(message, '', { timeOut: 7000 });
                break;
            default:
                this.toastr.error(message, '', { timeOut: 6000 });
                break;
        }

    }


}
